<template>
  <v-container>
    <p class="text-h5 pb-2">Account details</p>
    <p class="body pb-5">On this page you can find all details about your payments, account statistics, current balance. In case any incorrect payment details presented on this page, please contact us.</p>
    <v-row>
      <slot></slot>
    </v-row>
    <v-row>
      <v-col
          cols="6"
          md="3"
      >
        <p class="text-h6 text-center">Balance</p>
        <v-skeleton-loader
            v-if="loading"
            type="text@3"
        />
        <p v-else v-for="balance in balances" :key="balance" class="text-subtitle-1 text-center">{{ balance.balance }}</p>
      </v-col>
      <v-divider
          v-if="$vuetify.display.mdAndUp"
          :vertical="true"
      />
      <v-col
          cols="6"
          md="3"
      >
        <p class="text-h6 text-center">Hold</p>
        <v-skeleton-loader
            v-if="loading"
            type="text@3"
        />
        <p v-else v-for="balance in balances" :key="balance" class="text-subtitle-1 text-center">{{ balance.hold }}</p>
      </v-col>
      <v-divider
          v-if="$vuetify.display.mdAndUp"
          :vertical="true"
      />
      <v-col
          cols="6"
          md="3"
      >
        <p class="text-h6 text-center">Spent</p>
        <v-skeleton-loader
            v-if="loading"
            type="text@3"
        />
        <p v-else v-for="balance in balances" :key="balance" class="text-subtitle-1 text-center">{{ balance.spent}}</p>
      </v-col>
      <v-divider
          v-if="$vuetify.display.mdAndUp"
          :vertical="true"
      />
      <v-col
          cols="6"
          md="3"
      >
        <p class="text-h6 text-center">Requests finished</p>
        <v-skeleton-loader
            v-if="loading"
            type="text"
        />
        <p v-else class="text-subtitle-1 text-center">{{ requestsFinished }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default{
  name: "PaymentDetails",
  props: {
    balances: Array,
    requestsFinished: String,
    loading: Boolean
  }
}
</script>

<style scoped>

</style>